import React from 'react';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import News from 'Component/News/News';
import PressKit from '../components/Press/PressKit/PressKit';
import PressReleases from '../components/Press/PressReleases/PressReleases';

import NewsData from 'NewsData/Press.json';

const Press = () => {
	return (
		<Layout>
			<SEO title="Press" description="" />
			<h2 style={{ margin: '4rem 0', textAlign: 'center', color: '#164221' }}>
				Press
			</h2>
			<h4 className="textGreen">We've been covered on...</h4>
			<News data={NewsData} customClass="press" />
			<PressKit />
			<PressReleases />
		</Layout>
	);
};

export default Press;
